import { generateDescriptionMarkup, generateDescriptionMarkupWithImage } from './markup-utils';
import gifSrc from '@worklist-2/ui/src/assets/img/customize-toolbar-demo.gif';
import { nextButtonIcon } from './inline-icons';

export function getCustomizeToolbarOldMenuConfig() {
	return t => ({
		popoverClass: 'ramsoft-tutorial-popover',
		animate: true,
		doneBtnText: 'done',
		showProgress: true,
		progressText: 'Step {{current}} of {{total}}',
		allowKeyboardControl: false,
		showButtons: ['next'],
		onPopoverRender: (popover, { config, state }) => {
			const { activeIndex } = state;
			const isFirstStep = activeIndex === 0;
			const isLastStep = activeIndex === config.steps.length - 1;

			function proxyNextButtonForAutoTrigger(isTextBtn = true) {
				try {
					const elSelector = state.activeStep.element;
					const el = document.querySelector(elSelector);

					const nextButton = document.createElement('button');
					nextButton.innerText = popover.nextButton.innerText;
					if (isTextBtn) {
						nextButton.classList.add('text-btn', 'next-btn');
						nextButton.innerHTML = `${nextButton.innerText} ${nextButtonIcon}`;
					}
					popover.footerButtons.append(nextButton);
					popover.nextButton.style.display = 'none';
					const nextButtonClickHandler = () => {
						el.click();
					};
					nextButton.removeEventListener('click', nextButtonClickHandler);
					nextButton.addEventListener('click', nextButtonClickHandler);
				} catch (e) {
					console.log('error in next button cloning: ', e);
				}
			}
			if (isFirstStep) {
				const skipButton = document.createElement('button');
				skipButton.innerText = 'SKIP';
				skipButton.classList.add('text-btn');
				popover.footerButtons.append(skipButton);

				skipButton.addEventListener('click', () => {
					popover.closeButton?.click();
				});
				popover.nextButton.innerText = 'SHOW ME';
				proxyNextButtonForAutoTrigger(false);
			} else if (!isLastStep) {
				popover.nextButton.innerText = 'Next';
				proxyNextButtonForAutoTrigger();
			}
		},
		steps: [
			{
				stepNum: 1,
				element: '[data-tut="toolbar-menu"]',
				showButtons: ['close'],
				popover: {
					description: generateDescriptionMarkup(
						() => `
							<p>${t('customizeToolbar.meet')}</p>
						`
					),
					side: 'left',
					align: 'end',
				},
			},
			{
				stepNum: 2,
				element: '[data-tut="customizetoolbar-submenu-item"]',
				showButtons: ['close'],
				popover: {
					description: generateDescriptionMarkup(
						() => `
							<p>${t('customizeToolbar.clickCustomToolbar')}</p>
						`
					),
					side: 'left',
					align: 'end',
				},
			},
			{
				stepNum: 3,
				element: '[data-tut="customize-toolbar"]',
				showButtons: ['close'],
				popover: {
					description: generateDescriptionMarkupWithImage(
						() => `
							<img src=${gifSrc} alt="new obliquity line dot illustration" />
							<ul>
							  <li>${t('customizeToolbar.editPanelStep1')}</li>
							  <li>${t('customizeToolbar.editPanelStep2')}</li>
							  <li>${t('customizeToolbar.editPanelStep3')}</li>
							</ul>
						`,
						() => `
							${t('customizeToolbar.editPanelTitle')}
						`
					),
					side: 'top',
					align: 'center',
				},
			},
		],
	});
}
